module.exports = __webpack_public_path__ + "static/media/image04.6eed3bca.jpg";